<template lang="pug">
k-page.home
  template( v-if=`layout === 'suave'` :title='title' )
    k-browser-content
  template( v-else )
    d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
    k-hero
    w-go-down
    k-main( :title='title' )
      content-list( title='latest' :contents='latest' )
      filmstrip( title='trending' :contents='trending' )
      filmstrip( title='recent activity' :contents='recent' )
      filmstrip( title='pull up' :contents='history' )
      filmstrip( title='you might like' :contents='discovery' )
      filmstrip( title='my faves' :contents='favs' )
</template>

<script lang="js">
import { mapGetters, mapActions } from 'vuex'
import he from 'he'
import _wpapix from '@/lib/wpapix'
import routeEvents from '@/lib/route-events'
import DMainImage from '@/displays/d-main-image'
import KBrowserContent from '@/blocks/k-browser-content'
import KMain from '@/blocks/k-main'
import KHero from '@/blocks/k-hero'
import KPage from '@/blocks/k-page'
import WGoDown from '@/widgets/w-go-down'
import Filmstrip from '@/components/filmstrip'
import ContentList from '@/components/content-list'
import { User, Page } from '@/mixins'
import { Logger } from '@/lib/logger'

export default {
  name: 'HomePage',
  mixins: [ User, Page ],
  components: {
    DMainImage,
    KBrowserContent,
    KHero,
    KMain,
    KPage,
    WGoDown,
    Filmstrip,
    ContentList,
  },
  data () {
    return {
      promos: [],
      latest: [],
      trending: [],
      recent: [],
      history: [],
      discovery: [],
      favs: [],
    }
  },
  beforeRouteUpdate: routeEvents.toPath,
  mounted() {
    this.storedPost = Object.assign( {}, this.$store.state.post )
    this.maybeSetHero()
    document.title = he.decode( this.siteTitle )
    this.loading = false
  },
  methods: {
    ...mapActions([ 'setHero', 'updateHeroData' ]),
    maybeSetHero() {
      this.storedPost = Object.assign( {}, this.$store.state.post )
      if ( !this.storedPost ) {
        setTimeout( this.maybeSetHero, 4000 )
      } else {
        this.promos = this.storedPost.promo_reel || []
        if ( this.promos && this.promos.length ) {
          this.setHero({
            name: 'video-preview',
            data: {
              content: this.promos[0]
            }
          })
        }
      }
    },
  },
  computed: {
    ...mapGetters([ 'layout' ]),
    isSubscriber() {
      return this.user && (!this.user.as || this.user.as.subscriber ) &&
         this.user.membership
    }
  }
}
</script>

<style lang="scss">
.page.home {
  .k-browser-content {
    position: relative;
  }
}
</style>
